import { USER_FETCH_MERCHANT_USER_SUB_OPERATOR_REQUEST_SUCCESS } from 'constants/actionTypes';

const INITIAL_STATE = {
  payload: [],
  loading: false,
  errors: {},
  pagination: {
    current: 0,
    pageSize: 0,
    total: 0,
    totalPage: 0,
  },
};

const subOperatorsReducer = (state, action) => {
  state = state || INITIAL_STATE;

  switch (action.type) {
    case USER_FETCH_MERCHANT_USER_SUB_OPERATOR_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        payload: action.data,
        loading: false,
        errors: {},
        pagination: {
          current: action.data.currentPage,
          pageSize: action.data.pageSize,
          total: action.data.totalRecord,
          totalPage: action.data.totalPage,
          showSizeChanger: true,
        },
      });
    default:
      return state;
  }
};

export default subOperatorsReducer;
